import { graphql } from "~/gql/runtime";

export const fragment = graphql(`
  fragment Link on HyperLinkInterface {
    href: url
    text
    newWindow
  }
`);

export function stripTrailingSlash(str: string) {
  return str.replace(/^(.+?)\/*?$/, "$1");
}

export function normalizeUrl(href: string) {
  let url = href;

  if (url.startsWith("www.")) {
    url = url.replace("www.", "https://");
  }

  return stripTrailingSlash(url);
}

export function parsePublicToLocalHref(href: string) {
  let url = normalizeUrl(href);

  try {
    const { hostname, pathname, protocol, search, hash } = new URL(url);

    const isHttpLink = protocol.startsWith("http");

    const isInternalLink = hostname.includes("localhost") || process.env.NEXT_PUBLIC_URL.includes(hostname);

    if (isHttpLink && isInternalLink) {
      const modifiedPathname = pathname.replace(process.env.NEXT_PUBLIC_HOMEPAGE_SLUG, "/");
      url = `${modifiedPathname}${search}${hash}`;
    }
  } catch (e) {
    // console.error(e);
  }

  return stripTrailingSlash(url);
}

export function isLinkValid<T>(link?: T): link is NonNullable<T> {
  if (!link) {
    return false;
  }

  return "href" in (link as any) && Boolean((link as any).href);
}
